import { useMemo, useState } from 'react'
import { getOperacoesMovimentacaoInsumo } from '../../../../services/api/https/system/system.http'

export const LOADING_MESSAGES = {
  NONE: 'none',
  INITIAL_FETCH: 'Carregando as Operações de Movimentação de Insumos . . . ',
}

const NEW_OPERACAO = {
  id: null,
  name: '',
  type: '',
}

const INIT_STATE = {
  loadingMessage: LOADING_MESSAGES.NONE,
  errorMessage: null,
  operacoes: [],
  selectedOperacao: { ...NEW_OPERACAO },
  showModal: false,
}

export default function useOperacaoMovimentacaoInsumo() {
  const [state, setState] = useState({ ...INIT_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      setLoading(loadingMessage) {
        setState(prevState => ({ ...prevState, loadingMessage }))
      },

      getOperacoesMovimentacaoInsumos() {
        getOperacoesMovimentacaoInsumo()
          .then(operacoes => {
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOADING_MESSAGES.NONE,
              operacoes,
            }))
          })
          .catch(e => {
            setState(prevState => ({
              ...prevState,
              errorMessage: e,
              loadingMessage: LOADING_MESSAGES.NONE,
            }))
          })
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          errorMessage: null,
          loadingMessage: LOADING_MESSAGES.NONE,
          showModal: false,
        }))
      },

      // Events
      onItemClick(operacao) {
        setState(prevState => ({ ...prevState, showModal: true, selectedOperacao: operacao }))
      },

      onBtnNovoClick() {
        setState(prevState => ({
          ...prevState,
          showModal: true,
          selectedOperacao: { ...NEW_OPERACAO },
        }))
      },

      onModalResponse(action, payload) {
        if (action === 'close') {
          setState(prevState => ({
            ...prevState,
            showModal: false,
            selectedOperacao: { ...NEW_OPERACAO },
          }))
        } else if (action === 'error') {
          setState(prevState => ({ ...prevState, errorMessage: payload }))
        } else if (action === 'success') {
          if (payload) {
            setState(prevState => {
              const operacaoIndex = prevState.operacoes.findIndex(o => o.id === payload.id)
              if (operacaoIndex !== -1) {
                prevState.operacoes[operacaoIndex] = payload
              } else {
                prevState.operacoes.push(payload)
              }
              return { ...prevState, showModal: false }
            })
          }
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
